import React from 'react';
import { Box, Typography } from '@mui/material';

const NoAudioTranscript: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      textAlign="center"
      bgcolor="background.paper"
      p={2}
    >
      <Typography
        variant="h5"
        fontWeight={500}
        color="secondary.contrastText"
        mt={1}
      >
        No audio
      </Typography>
      <Typography variant="body1" color="text.secondary" mt={1}>
        A transcript would be here, but this recording has no audio track.
      </Typography>
    </Box>
  );
};

export default NoAudioTranscript;
